import App from './App.svelte';

var app = new App({
	// target: document.body
	target: document.getElementById('blz-client-portal-dashboard'),
});

export default app;